/*
 * Country selectors (snippets/header-country-selector.liquid,
 * footer-country-selector.liquid and nav-country-selector.liquid).
 *
 * The countries arrive once per page as data (snippets/country-list-data.liquid)
 * rather than as a printed list in each of the four selectors. A selector's list
 * ([data-country-list]) is built the first time its button ([data-country-toggle])
 * is pressed, with the link, flag and name classes that selector puts on the list.
 *
 * Choosing a country submits that selector's localization form. The theme's
 * localization-form element (src/js/core.js) only binds the options that exist
 * when it starts, so options built here are handled here.
 */
(function () {
  if (window.__scCountrySelector) return;
  window.__scCountrySelector = true;

  var data;
  function countryData() {
    if (data === undefined) {
      try { data = JSON.parse(document.getElementById('ScCountries').textContent); } catch (e) { data = null; }
    }
    return data;
  }

  function fill(list) {
    if (list.hasAttribute('data-filled')) return;
    var d = countryData();
    if (!d || !d.countries) return;
    var linkClass = list.getAttribute('data-link-class') || '';
    var imgClass = list.getAttribute('data-img-class') || '';
    var textClass = list.getAttribute('data-text-class') || '';
    var frag = document.createDocumentFragment();
    d.countries.forEach(function (c) {
      var item = document.createElement('li');
      item.className = 'disclosure__item';
      item.tabIndex = -1;
      var link = document.createElement('a');
      link.href = '#';
      link.className = 'country-option ' + linkClass;
      link.setAttribute('data-value', c.code);
      if (c.code === d.current) link.setAttribute('aria-current', 'true');
      var flag = document.createElement('img');
      flag.className = imgClass;
      flag.src = c.flag;
      flag.alt = ''; // the name is next to it
      flag.width = 40;
      flag.height = 40;
      flag.loading = 'lazy';
      flag.decoding = 'async';
      flag.style.aspectRatio = '1 / 1';
      flag.style.objectFit = 'cover';
      var name = document.createElement('span');
      name.className = textClass;
      name.textContent = c.name + ' (' + c.currency + ')';
      link.appendChild(flag);
      link.appendChild(name);
      item.appendChild(link);
      frag.appendChild(item);
    });
    list.appendChild(frag);
    list.setAttribute('data-filled', '');
  }

  // Capture phase: the list is built before the button's own handler opens it.
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var toggle = target.closest('[data-country-toggle]');
    if (toggle) {
      var list = toggle.parentElement && toggle.parentElement.querySelector('[data-country-list]');
      if (list) fill(list);
      return;
    }

    var option = target.closest('[data-country-list] .country-option');
    if (!option) return;
    e.preventDefault();
    var form = option.closest('form');
    var input = form && form.querySelector('input[name="country_code"]');
    if (!input) return;
    input.value = option.getAttribute('data-value');
    form.submit();
  }, true);
})();
